<template lang="pug">
    .text-muted.container 
        i.fa.fa-refresh.fa-spin
        |  {{$t('globals.loading')}}
</template>
<script>
import {mapGetters} from 'vuex'
import {success} from '@/components/shared/Notify'
export default {
  props: {
    answer: String,
    registerKey: String,
    userId: Number,
    eventId: Number
  },
  mounted() {
    this.$store.dispatch('events/putEventAnswerWithRegistrationKey', {
      eventId: this.eventId,
      answer: this.answer,
      userId: this.userId,
      registrationKey: this.registerKey
    }).finally(() => {
      this.$router.replace({
        name: 'Events',
        params: {
          groupId: -1
        },
        query: {
          m: 'shared',
          k: 'event',
          i: this.eventId
        }
      })
      if (!this.isConnected) {
        success(this._i18n.t('events.externalAnswerSuccessWithoutConnected'), {timeout: 15000})
      }
    })
  },
  computed: {
    ...mapGetters('user', [
      'isConnected'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// ExternalAnswer.vue?4b542084